import LocationWidget from './location-widget.component'

export default LocationWidget
